import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { Grid2 as Grid } from "@mui/material";
import colors from "../../theme/Colours";

export const checkDetailsStyles = {
  background: colors.checkDetailsButton,
  color: "black",
  width: "50%",
  border: `1px solid ${colors.buttonBGColor}`,
  padding: "6px 10px",
  borderRadius: "60px",
  cursor: "pointer",
  fontSize: "12px",
};

export const OuterContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`;

export const FullWidthBox = styled(Box)`
  width: 100%;
`;

export const AddSectionBox = styled(Box)``;

export const AddSectionGrid = styled(Grid)`
  margin-top: 60px;
`;

export const ButtonGridContainer = styled(Grid)`
  margin-top: 40px;
`;

export const ListSectionBox = styled(Box)`
  margin-top: 80px;
  margin-bottom: 40px;
`;

export const outlinedButtonStyles = {
  border: `1px solid ${colors.primaryButtonOrange}`,
  backgroundColor: "transparent",
  width: "100%",
  color: colors.primaryButtonOrange,
  whiteSpace: "nowrap",
  borderRadius: "8px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: colors.primaryButtonOrange,
    color: colors.background2,
    boxShadow: "none",
  },
};

export const containedButtonStyles = {
  backgroundColor: colors.primaryButtonOrange,
  color: colors.background2,
  width: "100%",
  whiteSpace: "nowrap",
  borderRadius: "8px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: colors.primaryButtonOrangeHover,
    boxShadow: "none",
  },
};
